import React from 'react';

import { useTranslation } from 'react-i18next';

import { Typography } from '@pkg/components';
import { useMediaQuery } from '@pkg/providers';

import { DRAGGABLE_CLASS_NAME_TO_IGNORE } from '../../DraggableMasonry';

import { IconWrapper, NFTPreviewButtonWrapper, StyledExpandIcon } from './styles';

interface Props {
    className?: string;
    canShow?: boolean;
    onClick: () => void;
}

export function NFTPreviewButton({ className, canShow = true, onClick }: Props) {
    const { desktop } = useMediaQuery();
    const { t } = useTranslation('yat_page');

    if (!desktop) return null;

    return (
        <NFTPreviewButtonWrapper
            className={`${className} ${DRAGGABLE_CLASS_NAME_TO_IGNORE}`}
            onClick={onClick}
            $canShow={canShow}
        >
            <Typography type="label" size={14} weight="400">
                {t('nft_preview')}
            </Typography>

            <IconWrapper>
                <StyledExpandIcon width={10} height={10} />
            </IconWrapper>
        </NFTPreviewButtonWrapper>
    );
}
